import { useMemo } from 'react'

const useSessionExpiry = (
  sessionExpiry: number | undefined | null,
  isEditingQuiz: boolean | undefined | null
): boolean => {
  return useMemo(() => {
    return Boolean(sessionExpiry && isEditingQuiz)
  }, [sessionExpiry, isEditingQuiz])
}

export default useSessionExpiry